import TrendsBreakdown from "../../../../components/AssetManagement/Overview/Trends/TrendsBreakdown/TrendsBreakdown";

const TrendsBreakdownScreen = () => {
  return (
    <>
      <TrendsBreakdown />
    </>
  );
};

export default TrendsBreakdownScreen;
